import { render, staticRenderFns } from "./editExchangeRate.vue?vue&type=template&id=21b3539c&lang=pug"
import script from "./editExchangeRate.vue?vue&type=script&lang=js"
export * from "./editExchangeRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports